import { call, put, select } from "redux-saga/effects";
import type {
  UpdateDefaultBranchRequestParams,
  UpdateDefaultBranchResponse,
} from "../requests/updateDefaultBranchRequest";
import updateDefaultBranchRequest from "../requests/updateDefaultBranchRequest";
import { validateResponse } from "sagas/ErrorSagas";
import { gitArtifactActions } from "git/store/gitArtifactSlice";
import type { UpdateDefaultBranchInitPayload } from "../store/actions/updateDefaultBranchActions";
import log from "loglevel";
import { captureException } from "@sentry/react";
import type { GitArtifactPayloadAction } from "git/store/types";
import { selectGitApiContractsEnabled } from "git/store/selectors/gitFeatureFlagSelectors";

export default function* updateDefaultBranchSaga(
  action: GitArtifactPayloadAction<UpdateDefaultBranchInitPayload>,
) {
  const { artifactDef } = action.payload;
  let response: UpdateDefaultBranchResponse | undefined;

  try {
    const params: UpdateDefaultBranchRequestParams = {
      branchName: action.payload.branchName,
    };

    const isGitApiContractsEnabled: boolean = yield select(
      selectGitApiContractsEnabled,
    );

    response = yield call(
      updateDefaultBranchRequest,
      artifactDef.artifactType,
      artifactDef.baseArtifactId,
      params,
      isGitApiContractsEnabled,
    );
    const isValidResponse: boolean = yield validateResponse(response);

    if (response && isValidResponse) {
      yield put(gitArtifactActions.updateDefaultBranchSuccess({ artifactDef }));
      location.reload();
    }
  } catch (e) {
    if (response && response.responseMeta.error) {
      const { error } = response.responseMeta;

      yield put(
        gitArtifactActions.updateDefaultBranchError({ artifactDef, error }),
      );
    } else {
      log.error(e);
      captureException(e);
    }
  }
}
